<template>
  <aside class="md:w-44 md:shrink-0">
    <nav aria-label="Menu samping" class="flex gap-2 md:flex-col">
      <RouterLink to="/" class="nav-link">Lelang</RouterLink>
      <RouterLink to="/users" class="nav-link">Pengguna</RouterLink>
      <RouterLink to="/profile" class="nav-link">Profil</RouterLink>
    </nav>
  </aside>
</template>
